/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { formatUserLocalTime } from "../../helpers/dateHelpers";

import { useTheme } from "@material-ui/core/styles";
import { List, Grid, Tooltip } from "@material-ui/core";

const StyledList = styled(({ theme, ...props }) => <List {...props} />)`
  dt {
    color: ${(props) => props.theme.palette.text.secondary};
    font-size: 8px;
  }

  dd {
    margin-left: 0;
    font-size: 12px;
  }

  .facility-details:hover {
    cursor: pointer;
  }
`;

const StyledGridCarrierDataItem = styled(Grid)`
  flex: 0 0 1;
`;

const StyledDd = styled.dd`
  overflow-wrap: break-word;
`;

function UpsSpotLegClaimInfo() {
  const theme = useTheme();
  const spotLegClaim = useSelector(
    (state) => state.spotLegDetails.spotLeg.spotLegClaim
  );
  const { carrier } = useSelector((state) => state.carrier);
  const { user } = useSelector((state) => state.user);

  const getClaimedBy = (email) => {
    if (email && email.split("").length > 25) {
      return (
        <Tooltip title={email}>
          <span>{`${email.slice(0, 25)}...`}</span>
        </Tooltip>
      );
    } else {
      return email;
    }
  };

  return (
    <>
      <StyledGridCarrierDataItem item style={{ width: 150 }}>
        <StyledList component="dl" theme={theme}>
          <dt>Carrier</dt>
          <StyledDd>{spotLegClaim && carrier ? carrier.carrierName : "--"}</StyledDd>
        </StyledList>
      </StyledGridCarrierDataItem>
      <StyledGridCarrierDataItem item style={{ paddingLeft: 16, width: 175 }}>
        <StyledList component="dl" theme={theme}>
          <dt>Claimed by</dt>
          <StyledDd>
            {spotLegClaim && user?.email ? getClaimedBy(user.email) : "--"}
          </StyledDd>
        </StyledList>
      </StyledGridCarrierDataItem>
      <StyledGridCarrierDataItem item style={{ paddingLeft: 16, width: 125 }}>
        <StyledList component="dl" theme={theme}>
          <dt>Claimed at</dt>
          <StyledDd>
            {spotLegClaim && spotLegClaim.claimDateUtc
              ? formatUserLocalTime(spotLegClaim.claimDateUtc)
              : "--"}
          </StyledDd>
        </StyledList>
      </StyledGridCarrierDataItem>
      <StyledGridCarrierDataItem item style={{ paddingLeft: 16, width: 150 }}>
        <StyledList component="dl" theme={theme}>
          <dt>Note</dt>
          <StyledDd>
            {spotLegClaim && spotLegClaim.carrierNote.length > 0
              ? spotLegClaim.carrierNote
              : "--"}
          </StyledDd>
        </StyledList>
      </StyledGridCarrierDataItem>
    </>
  );
}

export default UpsSpotLegClaimInfo;
